import API from '@/lib/API.js'
import LUM from '@/lib/LUM.js'
import comun from './comun.js'
const diagnosticos = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        }
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Diagnostico.traerTodos();
                data.sort(LUM.dynamicSort("Problema"));
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let diagnostico = state.Lista.find((x) => x.IdProblema == payload)
            commit("select", diagnostico)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                IdProblema: 0,
                Problema: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.IdProblema != 0) {
                data = await API.Diagnostico.modificar(state.Seleccionado);
                str += "Diagnostico modificado"
            } else {
                data = await API.Diagnostico.alta(state.Seleccionado);
                str += `nuevo Diagnostico de alta '${data.Problema}'`
            }
            let secs = await API.Diagnostico.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.IdProblema)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch,
            state
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.IdProblema != 0) {
                data = await API.Diagnostico.modificar(entidad);
                str += "Diagnostico modificado"
            } else {
                data = await API.Diagnostico.alta(entidad);
                str += `nuevo Diagnostico de alta '${data.Problema}'`
            }
            let secs = await API.Diagnostico.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.IdProblema)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Diagnostico.eliminar(id);
                str += "Diagnostico eliminado"
            }
            let ents = await API.Diagnostico.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default diagnosticos;